import { Col, Flex, Input, Row, Table } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

const { Search } = Input;

function SearchableTable({
  baseData = undefined,
  searchPlaceholder = 'Search...',
  onSearch = null,
  afterSearch = null,
  extra = null,
  searchValue = '',
  className = '',
  searchColumns = [],
  ...props
}) {
  const [filteredData, setFilteredData] = useState(baseData);
  const [searchTerm, setSearchTerm] = useState(searchValue);

  useEffect(() => {
    if (baseData) {
      const filterData = searchColumns.length
        ? baseData?.filter((item) =>
            searchColumns.some((column) =>
              item[column].toLowerCase().includes(searchTerm.toLowerCase()),
            ),
          )
        : baseData;
      setFilteredData(filterData);
    }
  }, [baseData, searchTerm, searchColumns]);

  useEffect(() => {
    const debouncedSearch = setTimeout(() => {
      if (onSearch) {
        onSearch(searchTerm);
      }
      if (afterSearch) {
        afterSearch(searchTerm);
      }
    }, 300);
    return () => clearTimeout(debouncedSearch);
  }, [searchTerm, onSearch, afterSearch]);

  return (
    <Flex vertical className={className} gap={8}>
      <Row align="middle" gutter={8}>
        <Col flex="auto">
          <Search
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder={searchPlaceholder}
            allowClear
          />
        </Col>
        <Col>{extra}</Col>
      </Row>
      <Table
        bordered
        dataSource={filteredData}
        // we want to be able to use ant design Table props
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
    </Flex>
  );
}

SearchableTable.propTypes = {
  // baseData will be different depending on objects in table
  // eslint-disable-next-line react/forbid-prop-types
  baseData: PropTypes.arrayOf(PropTypes.object),
  searchPlaceholder: PropTypes.string,
  onSearch: PropTypes.func,
  afterSearch: PropTypes.func,
  extra: PropTypes.element,
  searchValue: PropTypes.string,
  // We need className so we can create a styled SearchableTable
  className: PropTypes.string,
  searchColumns: PropTypes.arrayOf(PropTypes.string),
};

export default SearchableTable;
